import React, { useState, useEffect } from 'react'
import { useStockOutAndInListModel } from '../stockOutAndInListModel';
import { stockOutAndInListService } from "../stockOutAndInListService"
import { IDetailList, IStockBorrowDetail } from '../stockOutAndInListType';
import { ScaniaPrint, IPrintClumns } from "@/components/ScaniaPrint"
import useGlobalModel from '@/model/globalModel';
import { BorrowPrint } from '@/components/ScaniaPrint/borrowPrint';
export const BorrowPrints = () => {
    const { borrowPrint: { visible, type }, selectedRow, setBorrowPrint } = useStockOutAndInListModel()
    const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
    const onClose = () => {
        setBorrowPrint({ visible: false, type: 1 })
    }
    const [formVal, setFormVal] = useState<IStockBorrowDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await stockOutAndInListService.one(selectedRow.borrowCode as string);
        let { details, ...from } = retData

        const newMaterialDetails = details?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IDetailList[] ?? []);
            setFormVal({
                ...from,
            })

        }
    }
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '配件编码',
            dataIndex: 'materialCode',
        },
        {
            title: '配件名称',
            dataIndex: 'materialName',
        },
        {
            title: '借件数量',
            dataIndex: 'borrowNum',
        },
    ]

    return <BorrowPrint
        title={`${shopName}`}
        visible={visible}
        onClose={onClose}
        columns={columns as IPrintClumns[]}
        dataSource={maintenanceList}
        formVal={formVal}
        shopCode={shopCode}
        type={type}

    />
}
